import { render, staticRenderFns } from "./settlementDetail.vue?vue&type=template&id=e160fc36&scoped=true&"
import script from "./settlementDetail.vue?vue&type=script&lang=js&"
export * from "./settlementDetail.vue?vue&type=script&lang=js&"
import style0 from "./settlementDetail.vue?vue&type=style&index=0&id=e160fc36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e160fc36",
  null
  
)

export default component.exports